<!--
 * @Description: 首页
 * @Version:
 * @Author: 兰双
 * @LastEditTime: 2022-03-24 14:47:28
 * @LastEditors: Please set LastEditors
 * @Date: 2021-08-06 10:39:47
-->
<template>
	<div id="index" class="fon_14">
		<header :class="{ headerbgk: headBgk }">
			<div class="head color_f flex-bet">
				<div class="logo-box flex-grow-0 flex-y-center cursor" @click="$router.push('/')">
					<img class="logo" src="@/assets/imgs/logo.png" alt="西安工会科创平台" />
					<span class="fon_20">西安工会科技创新平台</span>
				</div>
				<div class="nav flex">
					<el-menu :default-active="this.$route.path" class="el-menu-demo" mode="horizontal"
						@select="handleSelect" background-color="transparent" text-color="#fff" router
						active-text-color="#ffffff">
						<template v-for="(item, index) in menuList">
							<el-menu-item :index="item.path" :key="item.title" v-if="item.type == 1">{{ item.title }}
							</el-menu-item>
							<el-submenu :index="index + '1'" :key="item.title" popper-class="el-submenu-mine" v-else>
								<template slot="title">
									<span class="title_spans" @click="selectPath(item)">{{ item.title }}</span>
								</template>
								<el-menu-item v-for="(val, j) in item.children" :key="j" :index="val.path">
									{{ val.title }}
								</el-menu-item>
							</el-submenu>
						</template>
					</el-menu>
					<!-- <p class="contract_res" @click="openContract">合同认定</p> -->
				</div>
				<div class="user-mesg flex-grow-0 flex-y-center hoverColor" @click="logo" v-if="!loginState">
					<span>
						<span class="el-icon-user mar_r-9 cursor"></span>
						<span class="cursor hoverColor">登录</span>
					</span>
				</div>
				<div class="user-mesg flex-grow-0 flex-y-center hoverColor" @click="register" v-if="!loginState">
					<span>
						<span class="el-icon-user mar_r-9 cursor"></span>
						<span class="cursor hoverColor">注册</span>
					</span>
				</div>

				<el-dropdown v-else>
					<span class="el-dropdown-link hoverColor cursor color_f"
						:class="$route.path == '/person_info' ? 'corFinnal' : ''">
						<span>
							<span class="el-icon-user mar_r-9 cursor"></span> {{ nickName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item class="clearfix">
							<p @click="tabPersonal">个人中心</p>
						</el-dropdown-item>
						<el-dropdown-item class="clearfix">
							<p @click="logoOut">退出登录</p>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</header>

		<!-- <iframe src="http://localhost:8000" ref="Frame" scrolling="auto"></iframe> -->
		<div class="containter">
			<router-view />
		</div>
		<div class="background_0 wid">
			<div class="color_f foot-copy flex-center">
				<a href="https://bszs.conac.cn/sitename?method=show&id=AD0D8316C6F15C62E05310291AAC3624"
					class="inline-block footer_img" target="_blank">
					<img src="@/assets/imgs/footerImg.png" class="footer_img" alt="" />
				</a>
				<div class="mar_l_12">
					<p>版权所有：西安市总工会</p>
					<p class="pad_t_6">
						<a href="https://beian.miit.gov.cn/" target="_blank" class="color_f">陕ICP备20002371号</a>
						<span class="mar_l_27">技术支持：029-87269202</span>
					</p>
				</div>
			</div>
		</div>
		<el-dialog title="注册" :visible.sync="dialogVisible" :close-on-click-modal="false" width="404px">
			<div style="font-size: 16px;margin-top: 15px;text-align: center;">
        <el-row>
			<el-col  style="margin-bottom: 36px" :span="12">
                <span @click="registerFun(1)"><a class="color_52 personal cursor">个人注册</a></span>
		</el-col>
		<el-col  style="margin-bottom: 36px" :span="12">
                <span @click="registerFun(2)"><a class="color_52 cursor">企业注册</a></span>
		</el-col>
        </el-row>
	</div>
		</el-dialog>
		<el-dialog title="登录" :visible.sync="dialogVisibleLogin" :close-on-click-modal="false" width="404px">
			<div style="font-size: 16px;margin-top: 15px;text-align: center;">
				<el-row>
					<el-col  style="margin-bottom: 36px" :span="12">
							<span @click="personLogin"><a class="color_52 personal cursor">个人登录</a></span>
					</el-col>
					<el-col  style="margin-bottom: 36px" :span="12">
							<span @click="compLogin"><a class="color_52 cursor">企业登录</a></span>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<!-- 一键置顶 -->
		<a @click="scrollTop">
			<img src="@/assets/imgs/scroll_top.png" alt="返回顶部" :class="[
			isShowScroll ? 'showSrcollIcon' : 'hideSrcollIcon',
			'scroll_top']" />
		</a>

		<!--  找回密码弹框  -->
		<el-dialog title="忘记密码" :visible.sync="dialogVisiblePsw" :close-on-click-modal="false" width="404px">
			<div class="dialog-body con_shadow">
				<div class="flex psw_box">
					<p class="color_3 fon_14">找回个人账户密码：</p>
					<p class="forget_psw flex-center cursor" @click="forgetPsw">
						找回密码
					</p>
				</div>
				<div class="flex psw_box">
					<p class="color_3 fon_14">找回企业账户密码：</p>
					<div>
						<p class="color_3 fon_14">请联系工作人员重置密码</p>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 去评分弹框-->
		<el-dialog title="专家评分" custom-class="specialistClass" :visible.sync="dialogSpecialist"
			:close-on-click-modal="false" width="404px">
			<div class="dialog-body rating_box">
				<div class="t_c">
					<img src="@/assets/imgs/person/rating_img.png" class="rating_img" alt="" />
					<div>您有待评分作品，请前往评分。</div>
				</div>
				<div class="rating_bottom flex-bet">
					<div class="rating_bottom_item t_c cursor" @click="dialogSpecialist = false">
						跳过
					</div>
					<div class="rating_bottom_item t_c cursor" @click="
						dialogSpecialist = false;
						$router.push('/workList_rating');">
						去评分
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="企业登录" :visible.sync="comDialogVisibleLogin" :close-on-click-modal="false" width="404px">
			<div style="font-size: 16px;margin-top: 15px;text-align: center;">
				<login @login="comLogin"></login>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		global
	} from "@/libs/global";
	import axios from "axios";

	export default {
		name: "",
		mixins: [],
		components: {
			login: () => import("../login/login.vue"),
		},
		data() {
			return {
				headBgk: false,
				activeIndex: "/match/recommend",
				loginState:false,
				menuList: [
					// {title: "推荐", path: "/match/recommend", type: 1},
					// {title: "赛事", path: "/match/list", type: 1},
					// {title: "作品", path: "/match/worksList", type: 1},
					{
						title: "首页",
						type: 1,
						path: "/home"
					},
					{
						title: "赛事",
						type: 2,
						path: "/match/recommend",
						children: [{
								title: "推荐",
								path: "/match/recommend"
							},
							{
								title: "赛事",
								path: "/match/list"
							},
							{
								title: "作品",
								path: "/match/worksList"
							},
						],
					},
					// {
					// 	title: "创新工作室",
					// 	type: 2,
					// 	path: "/office/list",
					// 	children: [
					// 		{
					// 			title: "活动",
					// 			path: "/office/list"
					// 		},
					// 		{
					// 			title: "工作室",
					// 			path: "/office/worksList"
					// 		},
					// 	],
					// },
					{
						title: "培训",
						type: 2,
						path: "/train/recommend",
						children: [{
								title: "推荐",
								path: "/train/recommend"
							},
							{
								title: "知识技能",
								path: "/train/skillList"
							},
							{
								title: "培训课程",
								path: "/train/courseList"
							},
						],
					},
					{
						title: "交流",
						type: 2,
						path: "/exchange/index",
						children: [{
								title: "推荐",
								path: "/exchange/index"
							},
							{
								title: "专题",
								path: "/exchange/topicIndex"
							},
							{
								title: "咨询",
								path: "/exchange/consultIndex"
							},
							{
								title: "调研",
								path: "/exchange/surveyAnswer"
							},
						],
					},
				],
				dialogVisible: false,
				dialogVisibleLogin:false,
				comDialogVisibleLogin:false,
				nickName: "",
				isShowScroll: false,
				dialogVisiblePsw: false, //找回密码
				dialogSpecialist: false, //专家评分
			};
		},
	async created() {
			this.activeIndex = this.$route.path;
			global.$on("logOut", () => {
				this.getInit();
				this.loginState=false
			});
			global.$on("login", () => {
				this.getInit();
				this.loginState=true
			});
			if(this.util.getToken()){
				console.log(this.util.getToken());
			await this.getUserInfo()
			global.$emit("login");
    }
		},
		mounted() {
			this.$refs.Frame.contentWindow.postMessage("发送的消息内容","*");
			window.addEventListener('message', function (e) {
				this.d = e.data
			}, false)
			this.getInit();
			window.addEventListener("scroll", this.srcollEvent);
		},
		watch: {
			$route: function(val) {
				this.headBgk = false;
				if (val.name == "match-detail") {
					this.headBgk = true;
				}
			},
		},
		methods: {
			comLogin(){
				this.comDialogVisibleLogin = false
				global.$emit("login");
			},
			async  getUserInfo() {
				let res=await this.request.get(`${this.api.getCurrentLoginUser.request.url}`)
				this.util.setMessage("userInfo", res.sysUser);
				let userType = res.sysUser.userType;
				this.util.setMessage("userType", userType);
			},
			tabPersonal() {
				this.activeIndex = "";
				setTimeout(() => {
					this.$router.push("/person_info");
				});
			},
			//获取用户姓名
			getInit() {
				if (this.util.getToken()) {
					let userInfo = this.util.getMessage("userInfo");
					this.nickName = userInfo.nickName;
					this.loginState=true
				} else {
					this.nickName = "";
				}
			},
			selectPath(e) {
				this.$router.push(e.path);
			},
			handleSelect(e) {
				console.log(e);
			},
			async logo() {
			this.dialogVisibleLogin=true
			},
		async personLogin(){
			this.dialogVisibleLogin=false
			let res=await axios({
			headers: {
				'source': 2
			},
			method: 'post',
			url: 'https://kcapi.xagh.net/iam/login/getRedirectUri'
			})
				window.location.href = res
			},
			compLogin(){
				this.dialogVisibleLogin=false
				this.comDialogVisibleLogin=true

			},
			register(){
				this.dialogVisible = true;
			},
			async isLogin(val) {
				if (val) {
					this.dialogVisible = false;
					let userInfo = this.util.getMessage("userInfo");

					this.nickName = userInfo.nickName;
					if (this.$route.path != "/match/recommend") {
						this.$router.push("/match/recommend");
					}
					if (userInfo.userType == 3) {
						await this.getMatchWorksMine();
					}
				}
			},
			scrollTop() {
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			/**
			 * @Description:  查找是否有评分
			 */
			async getMatchWorksMine() {
				this.request
					.post(
						`${this.api.matchWorksExpertScore.request.url}?pageSize=1&pageNum=1`, {
							gameId: "",
							industryId: "",
							reviewStatus: false,
						}
					)
					.then((res) => {
						if (res) {
							if (res.records.length > 0) {
								this.dialogSpecialist = true;
							}
						}
					});
			},
			srcollEvent(e) {
				this.isShowScroll = false;
				if (e.srcElement.scrollingElement.scrollTop > 100) {
					this.isShowScroll = true;
				}
			},
			/**
			 * @Description:监听跳转到注册页面 并关闭登录弹框
			 */
			registerFun(e) {
				this.dialogVisible = false;
				if (e == 0) {
					this.comDialogVisibleLogin=false
					this.dialogVisiblePsw = true;
				} else if (e == 1) {
					window.open('https://rz.xagh.net/login/userRegister.html')
					// this.$router.push("/userRegister");
				} else if (e == 2) {
					this.$router.push("/companyRegister");
				}
			},
			forgetPsw() {
				this.dialogVisiblePsw = false;
				this.$router.push("/forget_psw");
			},
			/**
			 * @Description:退出登录
			 */
			logoOut() {
				this.request
					.deletes(`${this.api.loginOut.request.url}`, {})
					.then((res) => {
						if (res) {
							sessionStorage.removeItem("token");
							global.$emit("logOut");
							this.$router.push("/match/list");
							if(window.sessionStorage.getItem('userType')!=2){
								window.location.href = 'https://rz.xagh.net/'
							}
						}
					});
			},
			/** 打开合同认定*/
			openContract() {
				window.open("http://210.12.174.1:8084/");
			},
		},
	};
</script>
<style lang='scss'>
iframe{
	z-index: 999;
	position:fixed;
	margin-left: 20%;
	margin-top: 100px;
	width: 60%;
	height: 700px;
}
	// 滚动条样式
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	::-webkit-scrollbar-thumb {
		background: #f2f7ff;
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	}

	header {
		background: rgba(0, 0, 0, 0.8);
		height: $headHeight;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 999;
	}

	.head,
	.foot,
	.foot-copy {
		width: $max-width;
		margin: 0 auto;
	}

	.logo {
		width: 43px;
		height: 43px;
		margin: 0 9px 0 0;
	}

	.circle {
		display: inline-block;
		width: 4px;
		height: 4px;
		background: #999999;
		border-radius: 50%;
		float: left;
		margin-top: 30px;
		margin-right: 61px;
	}

	.foot-copy {
		// padding: 17px 0;
		height: 88px;
		//padding-top: 17px;
	}

	.scroll_top {
		width: 66px;
		height: 66px;
		position: fixed;
		right: 102px;
		bottom: 230px;
		z-index: 100;
		cursor: pointer;
	}

	.showSrcollIcon {
		display: block;
	}

	.hideSrcollIcon {
		display: none;
	}

	.forget_psw {
		width: 75px;
		height: 28px;
		background: #5295f3;
		opacity: 1;
		border-radius: 4px;
		color: #ffffff;
	}

	.psw_box {
		padding: 10px 0;
	}

	.con_shadow {
		padding: 20px 0;
	}

	.hoverColor:hover {
		color: #7db3ff;
	}

	.corFinnal {
		color: #7db3ff !important;
	}

	.containter>div {
		min-height: calc(100vh - 88px);
	}  
	
	.personal {
    margin-right: 26px;
  }

	.rating_img {
		width: 200px;
		padding-top: 20px;
	}

	.rating_bottom {
		margin-top: 30px;
		border-top: 1px solid #e5e5e5;
		line-height: 47px;
	}

	.rating_bottom_item {
		width: 50%;
		color: #2d7bdc;
	}

	.rating_bottom_item:first-child {
		border-right: 1px solid #e5e5e5;
	}

	.specialistClass {
		padding: 0 !important;

		.el-dialog__title {
			padding-left: 20px;
		}
	}

	.footer_img {
		height: 70px;
	}

	.mar_l_12 {
		margin-left: 12px;
	}

	.mar_l_27 {
		margin-left: 27px;
	}

	.pad_t_6 {
		padding-top: 6px;
	}

	.contract_res {
		width: 120px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		font-size: 16px;
	}

	.contract_res:hover {
		background-color: rgba(225, 225, 225, 0.2) !important;
		cursor: pointer;
	}

	.title_spans {
		width: 135px;
		height: 60px;
		display: inline-block;
	}
	.el-menu--horizontal>.el-menu-item, .el-submenu__title {
	padding: 0;
	font-size: 16px;
	width: 135px;
	text-align: center;
	}
	.el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
	width: 135px;
	min-width: 135px;
	margin: 0;
	padding: 0;
	background: #000 !important;
	border-radius: 0;
	}
</style>
